(function () {
  'use strict';

  /**
   * SVGElement doesn't support .hidden — use setAttribute/removeAttribute.
   * @param {Element} btn
   * @param {boolean} isMuted
   */
  function syncIcons(btn, isMuted) {
    const iconOff = btn.querySelector('.pdp-product-benefits__audio-svg--off');
    const iconOn  = btn.querySelector('.pdp-product-benefits__audio-svg--on');
    if (isMuted) {
      iconOff?.removeAttribute('hidden');
      iconOn?.setAttribute('hidden', '');
    } else {
      iconOff?.setAttribute('hidden', '');
      iconOn?.removeAttribute('hidden');
    }
    btn.setAttribute('aria-label', isMuted ? 'Unmute video' : 'Mute video');
  }

  /** @param {HTMLElement} container */
  function initContainer(container) {
    const video = /** @type {HTMLVideoElement|null} */ (container.querySelector('[data-benefits-video]'));
    const btn   = /** @type {HTMLButtonElement|null} */ (container.querySelector('[data-audio-toggle]'));
    if (!video || !btn) return;

    // Sync icon to current muted state
    syncIcons(btn, video.muted);

    // Direct binding — avoids any stopPropagation from theme scripts
    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      video.muted = !video.muted;
      if (!video.muted && video.paused) video.play().catch(function () {});
      syncIcons(btn, video.muted);
    });
  }

  /** @param {Document|HTMLElement} root */
  function initAll(root) {
    root.querySelectorAll('[data-video-container]').forEach(function (container) {
      initContainer(/** @type {HTMLElement} */ (container));
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (e) {
    initAll(/** @type {HTMLElement} */ (e.target));
  });
})();
